export class FetchError extends Error {
    constructor(status, message, type, refresh, codes, blocked, objectName, quota, numberOfBytes, limit) {
        super(message);
        this.status = status;
        this.message = message;
        this.type = type;
        this.refresh = refresh;
        this.codes = codes;
        this.blocked = blocked;
        this.objectName = objectName;
        this.quota = quota;
        this.numberOfBytes = numberOfBytes;
        this.limit = limit;
    }
    static fromJson(status, json) {
        const error = new FetchError(status, json.message, json.type || 'unset', json.refresh, json.codes, json.blocked, json.objectName, json.quota, json.numberOfBytes, json.limit);
        const { type, message, stack, ...extra } = json !== null && json !== void 0 ? json : {};
        if (Object.keys(extra).length)
            error.extraData = extra;
        return error;
    }
    static async fromResponse(response) {
        var _a;
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.startsWith('application/json')) {
            return FetchError.fromJson(response.status, await response.json());
        }
        else
            return new FetchError(response.status, response.statusText, 'unknown');
    }
    toDescriptor() {
        return Object.assign({}, this);
    }
}
